export default __webpack_public_path__ + "static/apartment_b.318e45593443f83c4630d7c219b5ab0f.svg";